module.exports = __webpack_public_path__ + "static/media/app-store.2ed2da67.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-store.webp
// module id = 294
// module chunks = 0